"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _default;
    }
});
var _default = {
    v: "5.7.3",
    fr: 60,
    ip: 0,
    op: 130,
    w: 20,
    h: 20,
    nm: "loading icon 3",
    ddd: 0,
    assets: [],
    layers: [
        {
            ddd: 0,
            ind: 1,
            ty: 4,
            nm: "Shape Layer 6",
            sr: 1,
            ks: {
                o: {
                    a: 0,
                    k: 100,
                    ix: 11
                },
                r: {
                    a: 0,
                    k: 0,
                    ix: 10
                },
                p: {
                    a: 0,
                    k: [
                        9.969,
                        10.062,
                        0
                    ],
                    ix: 2
                },
                a: {
                    a: 0,
                    k: [
                        0,
                        0,
                        0
                    ],
                    ix: 1
                },
                s: {
                    a: 0,
                    k: [
                        100,
                        100,
                        100
                    ],
                    ix: 6
                }
            },
            ao: 0,
            shapes: [
                {
                    ty: "gr",
                    it: [
                        {
                            ind: 0,
                            ty: "sh",
                            ix: 1,
                            ks: {
                                a: 0,
                                k: {
                                    i: [
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ]
                                    ],
                                    o: [
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ]
                                    ],
                                    v: [
                                        [
                                            -7.938,
                                            -0.062
                                        ],
                                        [
                                            8,
                                            -0.062
                                        ]
                                    ],
                                    c: false
                                },
                                ix: 2
                            },
                            nm: "Path 1",
                            mn: "ADBE Vector Shape - Group",
                            hd: false
                        },
                        {
                            ty: "st",
                            c: {
                                a: 0,
                                k: [
                                    1,
                                    1,
                                    1,
                                    1
                                ],
                                ix: 3
                            },
                            o: {
                                a: 0,
                                k: 100,
                                ix: 4
                            },
                            w: {
                                a: 0,
                                k: 2,
                                ix: 5
                            },
                            lc: 1,
                            lj: 1,
                            ml: 4,
                            bm: 0,
                            nm: "Stroke 1",
                            mn: "ADBE Vector Graphic - Stroke",
                            hd: false
                        },
                        {
                            ty: "tr",
                            p: {
                                a: 0,
                                k: [
                                    0,
                                    0
                                ],
                                ix: 2
                            },
                            a: {
                                a: 0,
                                k: [
                                    0,
                                    0
                                ],
                                ix: 1
                            },
                            s: {
                                a: 0,
                                k: [
                                    100,
                                    100
                                ],
                                ix: 3
                            },
                            r: {
                                a: 0,
                                k: 0,
                                ix: 6
                            },
                            o: {
                                a: 0,
                                k: 100,
                                ix: 7
                            },
                            sk: {
                                a: 0,
                                k: 0,
                                ix: 4
                            },
                            sa: {
                                a: 0,
                                k: 0,
                                ix: 5
                            },
                            nm: "Transform"
                        }
                    ],
                    nm: "Shape 1",
                    np: 3,
                    cix: 2,
                    bm: 0,
                    ix: 1,
                    mn: "ADBE Vector Group",
                    hd: false
                },
                {
                    ty: "tm",
                    s: {
                        a: 1,
                        k: [
                            {
                                i: {
                                    x: [
                                        0.95
                                    ],
                                    y: [
                                        0.63
                                    ]
                                },
                                o: {
                                    x: [
                                        0.9
                                    ],
                                    y: [
                                        0
                                    ]
                                },
                                t: 40,
                                s: [
                                    0
                                ]
                            },
                            {
                                i: {
                                    x: [
                                        0.1
                                    ],
                                    y: [
                                        1
                                    ]
                                },
                                o: {
                                    x: [
                                        0.05
                                    ],
                                    y: [
                                        1.667
                                    ]
                                },
                                t: 80,
                                s: [
                                    90
                                ]
                            },
                            {
                                t: 100,
                                s: [
                                    100
                                ]
                            }
                        ],
                        ix: 1
                    },
                    e: {
                        a: 1,
                        k: [
                            {
                                i: {
                                    x: [
                                        0.95
                                    ],
                                    y: [
                                        -0.667
                                    ]
                                },
                                o: {
                                    x: [
                                        0.9
                                    ],
                                    y: [
                                        0
                                    ]
                                },
                                t: 40,
                                s: [
                                    0
                                ]
                            },
                            {
                                i: {
                                    x: [
                                        0.1
                                    ],
                                    y: [
                                        1
                                    ]
                                },
                                o: {
                                    x: [
                                        0.05
                                    ],
                                    y: [
                                        0.208
                                    ]
                                },
                                t: 80,
                                s: [
                                    20
                                ]
                            },
                            {
                                t: 100,
                                s: [
                                    100
                                ]
                            }
                        ],
                        ix: 2
                    },
                    o: {
                        a: 0,
                        k: 0,
                        ix: 3
                    },
                    m: 1,
                    ix: 2,
                    nm: "Trim Paths 1",
                    mn: "ADBE Vector Filter - Trim",
                    hd: false
                }
            ],
            ip: 40,
            op: 220,
            st: 40,
            bm: 0
        },
        {
            ddd: 0,
            ind: 2,
            ty: 4,
            nm: "Shape Layer 5",
            sr: 1,
            ks: {
                o: {
                    a: 0,
                    k: 100,
                    ix: 11
                },
                r: {
                    a: 0,
                    k: 0,
                    ix: 10
                },
                p: {
                    a: 0,
                    k: [
                        9.969,
                        10.062,
                        0
                    ],
                    ix: 2
                },
                a: {
                    a: 0,
                    k: [
                        0,
                        0,
                        0
                    ],
                    ix: 1
                },
                s: {
                    a: 0,
                    k: [
                        100,
                        100,
                        100
                    ],
                    ix: 6
                }
            },
            ao: 0,
            shapes: [
                {
                    ty: "gr",
                    it: [
                        {
                            ind: 0,
                            ty: "sh",
                            ix: 1,
                            ks: {
                                a: 0,
                                k: {
                                    i: [
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ]
                                    ],
                                    o: [
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ]
                                    ],
                                    v: [
                                        [
                                            -7.938,
                                            -0.062
                                        ],
                                        [
                                            8,
                                            -0.062
                                        ]
                                    ],
                                    c: false
                                },
                                ix: 2
                            },
                            nm: "Path 1",
                            mn: "ADBE Vector Shape - Group",
                            hd: false
                        },
                        {
                            ty: "st",
                            c: {
                                a: 0,
                                k: [
                                    1,
                                    1,
                                    1,
                                    1
                                ],
                                ix: 3
                            },
                            o: {
                                a: 0,
                                k: 100,
                                ix: 4
                            },
                            w: {
                                a: 0,
                                k: 2,
                                ix: 5
                            },
                            lc: 1,
                            lj: 1,
                            ml: 4,
                            bm: 0,
                            nm: "Stroke 1",
                            mn: "ADBE Vector Graphic - Stroke",
                            hd: false
                        },
                        {
                            ty: "tr",
                            p: {
                                a: 0,
                                k: [
                                    0,
                                    0
                                ],
                                ix: 2
                            },
                            a: {
                                a: 0,
                                k: [
                                    0,
                                    0
                                ],
                                ix: 1
                            },
                            s: {
                                a: 0,
                                k: [
                                    100,
                                    100
                                ],
                                ix: 3
                            },
                            r: {
                                a: 0,
                                k: 0,
                                ix: 6
                            },
                            o: {
                                a: 0,
                                k: 100,
                                ix: 7
                            },
                            sk: {
                                a: 0,
                                k: 0,
                                ix: 4
                            },
                            sa: {
                                a: 0,
                                k: 0,
                                ix: 5
                            },
                            nm: "Transform"
                        }
                    ],
                    nm: "Shape 1",
                    np: 3,
                    cix: 2,
                    bm: 0,
                    ix: 1,
                    mn: "ADBE Vector Group",
                    hd: false
                },
                {
                    ty: "tm",
                    s: {
                        a: 1,
                        k: [
                            {
                                i: {
                                    x: [
                                        0.95
                                    ],
                                    y: [
                                        0.63
                                    ]
                                },
                                o: {
                                    x: [
                                        0.9
                                    ],
                                    y: [
                                        0
                                    ]
                                },
                                t: 20,
                                s: [
                                    0
                                ]
                            },
                            {
                                i: {
                                    x: [
                                        0.1
                                    ],
                                    y: [
                                        1
                                    ]
                                },
                                o: {
                                    x: [
                                        0.05
                                    ],
                                    y: [
                                        1.667
                                    ]
                                },
                                t: 60,
                                s: [
                                    90
                                ]
                            },
                            {
                                t: 80,
                                s: [
                                    100
                                ]
                            }
                        ],
                        ix: 1
                    },
                    e: {
                        a: 1,
                        k: [
                            {
                                i: {
                                    x: [
                                        0.95
                                    ],
                                    y: [
                                        -0.667
                                    ]
                                },
                                o: {
                                    x: [
                                        0.9
                                    ],
                                    y: [
                                        0
                                    ]
                                },
                                t: 20,
                                s: [
                                    0
                                ]
                            },
                            {
                                i: {
                                    x: [
                                        0.1
                                    ],
                                    y: [
                                        1
                                    ]
                                },
                                o: {
                                    x: [
                                        0.05
                                    ],
                                    y: [
                                        0.208
                                    ]
                                },
                                t: 60,
                                s: [
                                    20
                                ]
                            },
                            {
                                t: 80,
                                s: [
                                    100
                                ]
                            }
                        ],
                        ix: 2
                    },
                    o: {
                        a: 0,
                        k: 0,
                        ix: 3
                    },
                    m: 1,
                    ix: 2,
                    nm: "Trim Paths 1",
                    mn: "ADBE Vector Filter - Trim",
                    hd: false
                }
            ],
            ip: 20,
            op: 200,
            st: 20,
            bm: 0
        },
        {
            ddd: 0,
            ind: 3,
            ty: 4,
            nm: "Shape Layer 2",
            sr: 1,
            ks: {
                o: {
                    a: 0,
                    k: 100,
                    ix: 11
                },
                r: {
                    a: 0,
                    k: 0,
                    ix: 10
                },
                p: {
                    a: 0,
                    k: [
                        9.969,
                        10.062,
                        0
                    ],
                    ix: 2
                },
                a: {
                    a: 0,
                    k: [
                        0,
                        0,
                        0
                    ],
                    ix: 1
                },
                s: {
                    a: 0,
                    k: [
                        100,
                        100,
                        100
                    ],
                    ix: 6
                }
            },
            ao: 0,
            shapes: [
                {
                    ty: "gr",
                    it: [
                        {
                            ind: 0,
                            ty: "sh",
                            ix: 1,
                            ks: {
                                a: 0,
                                k: {
                                    i: [
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ]
                                    ],
                                    o: [
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ]
                                    ],
                                    v: [
                                        [
                                            -7.938,
                                            -0.062
                                        ],
                                        [
                                            8,
                                            -0.062
                                        ]
                                    ],
                                    c: false
                                },
                                ix: 2
                            },
                            nm: "Path 1",
                            mn: "ADBE Vector Shape - Group",
                            hd: false
                        },
                        {
                            ty: "st",
                            c: {
                                a: 0,
                                k: [
                                    1,
                                    1,
                                    1,
                                    1
                                ],
                                ix: 3
                            },
                            o: {
                                a: 0,
                                k: 100,
                                ix: 4
                            },
                            w: {
                                a: 0,
                                k: 2,
                                ix: 5
                            },
                            lc: 1,
                            lj: 1,
                            ml: 4,
                            bm: 0,
                            nm: "Stroke 1",
                            mn: "ADBE Vector Graphic - Stroke",
                            hd: false
                        },
                        {
                            ty: "tr",
                            p: {
                                a: 0,
                                k: [
                                    0,
                                    0
                                ],
                                ix: 2
                            },
                            a: {
                                a: 0,
                                k: [
                                    0,
                                    0
                                ],
                                ix: 1
                            },
                            s: {
                                a: 0,
                                k: [
                                    100,
                                    100
                                ],
                                ix: 3
                            },
                            r: {
                                a: 0,
                                k: 0,
                                ix: 6
                            },
                            o: {
                                a: 0,
                                k: 100,
                                ix: 7
                            },
                            sk: {
                                a: 0,
                                k: 0,
                                ix: 4
                            },
                            sa: {
                                a: 0,
                                k: 0,
                                ix: 5
                            },
                            nm: "Transform"
                        }
                    ],
                    nm: "Shape 1",
                    np: 3,
                    cix: 2,
                    bm: 0,
                    ix: 1,
                    mn: "ADBE Vector Group",
                    hd: false
                },
                {
                    ty: "tm",
                    s: {
                        a: 1,
                        k: [
                            {
                                i: {
                                    x: [
                                        0.95
                                    ],
                                    y: [
                                        0.63
                                    ]
                                },
                                o: {
                                    x: [
                                        0.9
                                    ],
                                    y: [
                                        0
                                    ]
                                },
                                t: 0,
                                s: [
                                    0
                                ]
                            },
                            {
                                i: {
                                    x: [
                                        0.1
                                    ],
                                    y: [
                                        1
                                    ]
                                },
                                o: {
                                    x: [
                                        0.05
                                    ],
                                    y: [
                                        1.667
                                    ]
                                },
                                t: 40,
                                s: [
                                    90
                                ]
                            },
                            {
                                t: 60,
                                s: [
                                    100
                                ]
                            }
                        ],
                        ix: 1
                    },
                    e: {
                        a: 1,
                        k: [
                            {
                                i: {
                                    x: [
                                        0.95
                                    ],
                                    y: [
                                        -0.667
                                    ]
                                },
                                o: {
                                    x: [
                                        0.9
                                    ],
                                    y: [
                                        0
                                    ]
                                },
                                t: 0,
                                s: [
                                    0
                                ]
                            },
                            {
                                i: {
                                    x: [
                                        0.1
                                    ],
                                    y: [
                                        1
                                    ]
                                },
                                o: {
                                    x: [
                                        0.05
                                    ],
                                    y: [
                                        0.208
                                    ]
                                },
                                t: 40,
                                s: [
                                    20
                                ]
                            },
                            {
                                t: 60,
                                s: [
                                    100
                                ]
                            }
                        ],
                        ix: 2
                    },
                    o: {
                        a: 0,
                        k: 0,
                        ix: 3
                    },
                    m: 1,
                    ix: 2,
                    nm: "Trim Paths 1",
                    mn: "ADBE Vector Filter - Trim",
                    hd: false
                }
            ],
            ip: 0,
            op: 180,
            st: 0,
            bm: 0
        },
        {
            ddd: 0,
            ind: 4,
            ty: 4,
            nm: "Shape Layer 4",
            sr: 1,
            ks: {
                o: {
                    a: 0,
                    k: 25,
                    ix: 11
                },
                r: {
                    a: 0,
                    k: 0,
                    ix: 10
                },
                p: {
                    a: 0,
                    k: [
                        9.969,
                        10.062,
                        0
                    ],
                    ix: 2
                },
                a: {
                    a: 0,
                    k: [
                        0,
                        0,
                        0
                    ],
                    ix: 1
                },
                s: {
                    a: 0,
                    k: [
                        100,
                        100,
                        100
                    ],
                    ix: 6
                }
            },
            ao: 0,
            shapes: [
                {
                    ty: "gr",
                    it: [
                        {
                            ind: 0,
                            ty: "sh",
                            ix: 1,
                            ks: {
                                a: 0,
                                k: {
                                    i: [
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ]
                                    ],
                                    o: [
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ]
                                    ],
                                    v: [
                                        [
                                            -7.938,
                                            -0.062
                                        ],
                                        [
                                            8,
                                            -0.062
                                        ]
                                    ],
                                    c: false
                                },
                                ix: 2
                            },
                            nm: "Path 1",
                            mn: "ADBE Vector Shape - Group",
                            hd: false
                        },
                        {
                            ty: "st",
                            c: {
                                a: 0,
                                k: [
                                    1,
                                    1,
                                    1,
                                    1
                                ],
                                ix: 3
                            },
                            o: {
                                a: 0,
                                k: 100,
                                ix: 4
                            },
                            w: {
                                a: 0,
                                k: 2,
                                ix: 5
                            },
                            lc: 1,
                            lj: 1,
                            ml: 4,
                            bm: 0,
                            nm: "Stroke 1",
                            mn: "ADBE Vector Graphic - Stroke",
                            hd: false
                        },
                        {
                            ty: "tr",
                            p: {
                                a: 0,
                                k: [
                                    0,
                                    0
                                ],
                                ix: 2
                            },
                            a: {
                                a: 0,
                                k: [
                                    0,
                                    0
                                ],
                                ix: 1
                            },
                            s: {
                                a: 0,
                                k: [
                                    100,
                                    100
                                ],
                                ix: 3
                            },
                            r: {
                                a: 0,
                                k: 0,
                                ix: 6
                            },
                            o: {
                                a: 0,
                                k: 100,
                                ix: 7
                            },
                            sk: {
                                a: 0,
                                k: 0,
                                ix: 4
                            },
                            sa: {
                                a: 0,
                                k: 0,
                                ix: 5
                            },
                            nm: "Transform"
                        }
                    ],
                    nm: "Shape 1",
                    np: 3,
                    cix: 2,
                    bm: 0,
                    ix: 1,
                    mn: "ADBE Vector Group",
                    hd: false
                },
                {
                    ty: "tm",
                    s: {
                        a: 0,
                        k: 0,
                        ix: 1
                    },
                    e: {
                        a: 0,
                        k: 100,
                        ix: 2
                    },
                    o: {
                        a: 0,
                        k: 0,
                        ix: 3
                    },
                    m: 1,
                    ix: 2,
                    nm: "Trim Paths 1",
                    mn: "ADBE Vector Filter - Trim",
                    hd: false
                }
            ],
            ip: 0,
            op: 182,
            st: 0,
            bm: 0
        }
    ],
    markers: []
};

//# sourceMappingURL=defaultLoadingBarAnimationWhite.js.map